import React, { useState, useEffect } from "react";
import "./HomePage.css";
import PageLayout from "../../components/ui/PageLayout";
import AvailableVideos from "./AvailableVideos";
import GrabBitePlayer from "./GrabBitePlayer";
import { isMobileDevice } from "../../utils/deviceDetection";
import MobileRestrictionMessage from "../../components/MobileRestrictionMessage";

const HomePage = () => {
	// Check if user is on mobile device
	const [isMobile, setIsMobile] = useState(false);

	useEffect(() => {
		const checkMobile = () => {
			setIsMobile(isMobileDevice());
		};

		// Check on mount
		checkMobile();

		// Check on window resize
		window.addEventListener('resize', checkMobile);
		
		return () => {
			window.removeEventListener('resize', checkMobile);
		};
	}, []);

	// If mobile, show restriction message
	if (isMobile) {
		return <MobileRestrictionMessage />;
	}

    const isGuest =
		//!!localStorage.getItem("accessToken") && !localStorage.getItem("idToken");
		!localStorage.getItem("idToken");

	return (
		<PageLayout>
			<div className="flex justify-between items-center">
				<h1 className="text-3xl font-semibold">
					{isGuest ? (
						<span>Welcome guest user!</span>
					) : (
						<span>Welcome to Pounce!</span>
					)}					
				</h1>
				<AvailableVideos />
			</div>
			<GrabBitePlayer />
		</PageLayout>
	);
};

export default HomePage;
